import createSvgIcon from "./utils/create_icon"

const FrameThicknessLarge = createSvgIcon(<path d="M6 3a3 3 0 0 0-3 3v15h8V11h10V3z" fill="currentColor" />, "FrameThicknessLarge")
export default FrameThicknessLarge
